import { Spin } from 'antd';

export const AnalyticsSpinner = () => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      height: '100%',
      paddingTop: 12,
      paddingBottom: 12,
    }}
  >
    <Spin size='large' />
  </div>
);
